import { Capability } from "@/global/constants";
import { DefaultRange } from "./default-range";

export type AdditionalFilterConfig = {
  /** Column name (case-insensitive match against system template columns). */
  field: string;
  /** Filter operator sent to the API. Defaults to "IN" when omitted. */
  operator?: string;
  /** Static list of values to use as the default filter. */
  values?: string[];
  dataSource?: {
    /** Pinia store ID, e.g. "system-template-builder". */
    store: string;
    /** State property name on that store, e.g. "systemTemplates". */
    state: string;
  };
};

type FilterDefaults = {
  dateFormat: string;
  defaultFrom?: string;
  defaultTo?: string;
  defaultRange?: DefaultRange | string;
  defaultLabel: string;
  additionalFilters?: AdditionalFilterConfig[];
};

export const DEFAULT_FILTERS: Record<Capability | "default", FilterDefaults> = {
  default: {
    dateFormat: "yyyy-MM-dd",
    defaultRange: DefaultRange.Last30,
    defaultLabel: "Date"
  },
  [Capability.SHIPMENTS]: {
    dateFormat: "yyyy-MM-dd",
    defaultRange: DefaultRange.Last3Months,
    defaultLabel: "Subscribed On"
  },
  [Capability.AIR_SHIPMENTS]: {
    dateFormat: "yyyy-MM-dd",
    defaultRange: DefaultRange.Last3Months,
    defaultLabel: "ETA"
  },
  [Capability["D&D"]]: {
    dateFormat: "yyyy-MM-dd",
    defaultRange: DefaultRange.Last3Months,
    defaultLabel: "ETA"
  },
  [Capability.MAERSK_RISK_MANAGEMENT]: {
    dateFormat: "yyyy-MM-dd",
    defaultRange: DefaultRange.RiskManagement,
    defaultLabel: "Latest ETA",
    additionalFilters: [
      {
        field: "Milestone Status",
        operator: "EQUAL",
        dataSource: { store: "system-template-builder", state: "systemTemplates" }
      }
    ]
  },
  [Capability.PORT_CONGESTION]: {
    dateFormat: "yyyy-MM-dd",
    defaultRange: DefaultRange.PortCongestion,
    defaultLabel: "ETA"
  },
  [Capability.EMISSIONS]: {
    dateFormat: "yyyy-MM-dd",
    defaultRange: DefaultRange.Emissions,
    defaultLabel: "ETA"
  }
};

export type DefaultFilters = typeof DEFAULT_FILTERS;
